import React from 'react';

const PdfGenerationLoader = ({ isVisible, progress = 0 }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-grayBgNormal rounded-lg p-8 w-[32.375rem] mx-4 shadow-xl">
        <div className="text-center">
          <h3 className="text-xl  text-textPrimary mb-2">
            Please hold on, we're generating your PDF
          </h3>
          <p className="text-base text-textSecondary mb-6">
            This may take a little time the first time but we promise it's worth the wait :D Please don't close this window
          </p>

          {/* Progress Bar */}
          <div className='flex gap-2 items-center'>
            <div className="w-full bg-neutral50B rounded-full h-2 overflow-hidden">
              <div
                className="bg-[#137959] h-[.58rem] rounded-full transition-all duration-500 ease-in-out transform"
                style={{
                  width: `${Math.round(progress)}%`,
                  transition: 'width 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
              ></div>
            </div>

            {/* Progress Text */}
            <p className="text-sm font-medium text-textSecondary transition-all duration-300">
              {Math.round(progress)}%
            </p>

          </div>

        </div>
      </div>
    </div>
  );
};

export default PdfGenerationLoader;
